import './BetbookPostMoreOptionsDialog.less';

import React from 'react';
import { DialogBody, DialogTitle, Docked } from '@/ui/dialogs/Dialog';
import PopupNg from '@/ui/PopupNg';
import i18n from '@i18n';
import { DialogRowButton, DialogRowIcon, DialogRowText } from '@/ui/dialogs/DialogRow';
import TrashInCircleIcon from '@/icons/TrashInCircleIcon';
import ReclamationIcon from '@/icons/ReclamationIcon';
import EditIcon from '@/icons/EditIcon';
import { navigate } from '@/routing';
import { deletePost } from '@/betbook/handlers';
import { betbookEditRoute } from '@/betbook/utils';
import { useBetbookLastParam } from 'nike-ui/src/components/betbook/utils';

function BetbookPostMoreOptionsDialog({ postType, postId, editable }) {
    return (
        <Docked className="betbook-post-options-dialog">
            <DialogTitle>
                <h2 className="betbook-post-options-dialog">{i18n('betbook.userPost')}</h2>
            </DialogTitle>
            <DialogBody>
                <BetbookPostMoreOptionsTooltip postType={postType} postId={postId} editable={editable} />
            </DialogBody>
        </Docked>
    );
}

export function BetbookPostMoreOptionsTooltip({ postType, postId, editable }) {
    const [lastParam] = useBetbookLastParam();

    function reportPost() {
        PopupNg.dispatcher.open('betbook/postReport', { postType, postId }, 10);
    }

    function editPost() {
        navigate(betbookEditRoute(postType), { postId });
    }

    function onDeletePost() {
        PopupNg.dispatcher.show(
            {
                title: i18n('betbook.post.delete'),
                messages: i18n('betbook.deletePopup.text'),
                buttons: [[i18n('commons.delete'), deletePost(postType, postId, lastParam)], ['jsp.message.zavriet']]
            },
            2
        );
    }

    return editable ? (
        <>
            <DialogRowButton onClick={editPost}>
                <DialogRowIcon>
                    <EditIcon />
                </DialogRowIcon>
                <DialogRowText>{i18n('betbook.post.edit')}</DialogRowText>
            </DialogRowButton>
            <DialogRowButton onClick={onDeletePost}>
                <DialogRowIcon>
                    <TrashInCircleIcon />
                </DialogRowIcon>
                <DialogRowText>{i18n('betbook.post.delete')}</DialogRowText>
            </DialogRowButton>
        </>
    ) : (
        <DialogRowButton onClick={reportPost}>
            <DialogRowIcon>
                <ReclamationIcon />
            </DialogRowIcon>
            <DialogRowText>{i18n('betbook.post.report')}</DialogRowText>
        </DialogRowButton>
    );
}

export default BetbookPostMoreOptionsDialog;
